import api from '@/api'

export default {
  fetch (contractId, recommendedRisk, query, tag, limit, page) {
    return api.get('/investments', {
      params: {
        contract_id: contractId,
        query,
        tag,
        limit,
        page,
        sort: `wesave_notes.${recommendedRisk}`
      }
    })
  },
  fetchByIsin (isin) {
    return api.get(`/investments/${isin}`)
  },
  fetchTags () {
    return api.get('/tags')
  }
}
